import { toast } from "react-toastify";
import { i18n } from "../../../translate/i18n";
import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, IconButton, Typography, Box,
  Grid, Divider
} from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import AddIcon from "@material-ui/icons/Add";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import Tooltip from "@material-ui/core/Tooltip";
import FileManagerSelectorModal from "../../../components/FileManagerSelectorModal";

const FlowBuilderCarouselModal = ({ node, onClose, onSave }) => {
  const [name, setName] = useState("");
  const [body, setBody] = useState("");
  const [selectorModalOpen, setSelectorModalOpen] = useState(false);
  const [activeCardIndex, setActiveCardIndex] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [cards, setCards] = useState([
    { id: "card_1", imageURL: "", headerText: "", bodyText: "", buttons: [{ id: "btn_1", text: "", type: "reply", payload: "" }] }
  ]);

  useEffect(() => {
    if (node && node.data) {
      setName(node.data.name || "Carrusel");
      setBody(node.data.body || "");
      if (node.data.cards && node.data.cards.length > 0) {
        setCards(node.data.cards);
      }
    }
  }, [node]);

  const handleSave = () => {
    const btnTexts = [];
    for (const card of cards) {
      if (!card.imageURL || card.imageURL.trim() === '') {
        toast.error(i18n.t("quickMessages.dialog.interactives.errors.emptyImageURL"));
        return;
      }
      for (const btn of card.buttons) {
        const trimmed = btn.text.trim();
        if (!trimmed) {
          toast.error(i18n.t("quickMessages.dialog.interactives.errors.emptyButtonText"));
          return;
        }
        if (btnTexts.includes(trimmed.toLowerCase())) {
          toast.error(i18n.t("quickMessages.dialog.interactives.errors.duplicateButtonText", { text: trimmed }));
          return;
        }
        btnTexts.push(trimmed.toLowerCase());
      }
    }
    onSave({ name, body, cards });
  };

  const addCard = () => {
    if (cards.length >= 10) return;
    setCards([...cards, { id: `card_${Date.now()}`, imageURL: "", headerText: "", bodyText: "", buttons: [{ id: "btn_1", text: "", type: "reply", payload: "" }] }]);
  };

  const removeCard = (index) => {
    setCards(cards.filter((_, i) => i !== index));
  };

  const updateCard = (index, field, value) => {
    const newCards = [...cards];
    newCards[index][field] = value;
    setCards(newCards);
  };

  const updateCardButton = (cardIndex, btnIndex, field, value) => {
    const newCards = [...cards];
    newCards[cardIndex].buttons[btnIndex][field] = value;
    setCards(newCards);
  };

  const addCardButton = (cardIndex) => {
    const newCards = [...cards];
    if (newCards[cardIndex].buttons.length >= 2) return; // Limite 2 botones por card
    newCards[cardIndex].buttons.push({ id: `btn_${Date.now()}`, text: "", type: "reply", payload: "" });
    setCards(newCards);
  };
  
  const removeCardButton = (cardIndex, btnIndex) => {
    const newCards = [...cards];
    newCards[cardIndex].buttons = newCards[cardIndex].buttons.filter((_, i) => i !== btnIndex);
    setCards(newCards);
  };

  return (
    <>
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Editar Carrusel Interactivo</DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <TextField
            fullWidth
            label="Nombre del Nodo"
            value={name}
            onChange={(e) => setName(e.target.value)}
            variant="outlined"
            margin="dense"
          />
        </Box>
        <Box mb={2}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label="Mensaje Introductorio (Body)"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            variant="outlined"
            margin="dense"
          />
        </Box>

        <Divider style={{ margin: '20px 0' }} />
        <Typography variant="h6" gutterBottom>Tarjetas (Máx 10)</Typography>
        
        {cards.map((card, cIndex) => (
          <Box key={card.id} border={1} borderColor="grey.300" borderRadius={4} p={2} mb={2}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={11}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Tarjeta {cIndex + 1}</Typography>
                <Box display="flex" alignItems="flex-start" mt={1}>
                  <Box flexGrow={1}>
                    <TextField
                      fullWidth
                      label="URL de Imagen (Obligatorio en Carrusel)"
                      value={card.imageURL}
                      onChange={(e) => updateCard(cIndex, "imageURL", e.target.value)}
                      variant="outlined"
                      margin="dense"
                    />
                  </Box>
                  <Tooltip title="Abrir Administrador de Archivos">
                    <Button
                      variant="outlined"
                      color="primary"
                      style={{ marginTop: 8, marginLeft: 8, height: 40 }}
                      onClick={() => {
                        setActiveCardIndex(cIndex);
                        setSelectorModalOpen(true);
                      }}
                    >
                      <FolderOpenIcon />
                    </Button>
                  </Tooltip>
                </Box>
                {card.imageURL && (
                  <Box mt={1} mb={1} display="flex" alignItems="center">
                    <img 
                      src={card.imageURL} 
                      alt="Preview" 
                      style={{ height: 60, width: 60, objectFit: 'cover', borderRadius: 4, cursor: 'pointer', border: '1px solid #ccc' }} 
                      onClick={() => setPreviewImage(card.imageURL)}
                    />
                    <Typography variant="caption" color="textSecondary" style={{ marginLeft: 8 }}>
                      Clic en la imagen para ampliar
                    </Typography>
                  </Box>
                )}
                <TextField
                  fullWidth
                  label="Título (Header) (Máx. 80)"
                  value={card.headerText}
                  onChange={(e) => updateCard(cIndex, "headerText", e.target.value.substring(0, 80))}
                  variant="outlined"
                  margin="dense"
                />
                <TextField
                  fullWidth
                  label="Descripción (Body) (Máx. 160)"
                  value={card.bodyText}
                  onChange={(e) => updateCard(cIndex, "bodyText", e.target.value.substring(0, 160))}
                  variant="outlined"
                  margin="dense"
                />

                <Box mt={2}>
                  <Typography variant="subtitle2" color="textSecondary">Botones de esta tarjeta (Máx 2)</Typography>
                  {card.buttons.map((btn, bIndex) => (
                    <Box key={btn.id} display="flex" alignItems="center" mt={1}>
                      <TextField
                        label="Texto del botón (Máx. 20)"
                        value={btn.text}
                        onChange={(e) => updateCardButton(cIndex, bIndex, "text", e.target.value.substring(0, 20))}
                        variant="outlined"
                        size="small"
                        style={{ marginRight: 8, flexGrow: 1 }}
                      />
                      <TextField
                        label="ID o Payload"
                        value={btn.payload}
                        onChange={(e) => updateCardButton(cIndex, bIndex, "payload", e.target.value)}
                        variant="outlined"
                        size="small"
                        style={{ marginRight: 8 }}
                      />
                      <IconButton size="small" color="secondary" onClick={() => removeCardButton(cIndex, bIndex)}>
                        <DeleteOutlineIcon />
                      </IconButton>
                    </Box>
                  ))}
                  {card.buttons.length < 2 && (
                    <Button size="small" startIcon={<AddIcon />} onClick={() => addCardButton(cIndex)}>
                      Añadir Botón
                    </Button>
                  )}
                </Box>
              </Grid>
              <Grid item xs={1} style={{ textAlign: 'center' }}>
                <IconButton color="secondary" onClick={() => removeCard(cIndex)} disabled={cards.length === 1}>
                  <DeleteOutlineIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Box>
        ))}
        {cards.length < 10 && (
          <Button variant="outlined" color="primary" startIcon={<AddIcon />} onClick={addCard} fullWidth>
            Añadir Nueva Tarjeta
          </Button>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">Guardar</Button>
      </DialogActions>
    </Dialog>
      <FileManagerSelectorModal
        open={selectorModalOpen}
        onClose={() => {
          setSelectorModalOpen(false);
          setActiveCardIndex(null);
        }}
        onSelect={(path) => {
          if (activeCardIndex !== null) {
            updateCard(activeCardIndex, "imageURL", path);
          }
        }}
        filterType="image"
      />

      <Dialog open={!!previewImage} onClose={() => setPreviewImage(null)} maxWidth="md">
        <DialogTitle>Vista Previa de Imagen</DialogTitle>
        <DialogContent style={{ textAlign: 'center' }}>
          {previewImage && <img src={previewImage} alt="Preview" style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }} />}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPreviewImage(null)} color="primary">Cerrar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FlowBuilderCarouselModal;
